export const PRESET_VOICES = [
  { id: "female-american-rachel", name: "Rachel", gender: "female", tone: "Calm & professional" },
  { id: "female-american-sarah", name: "Sarah", gender: "female", tone: "Soft & pleasant" },
  { id: "female-american-emily", name: "Emily", gender: "female", tone: "Clear & calm" },
  { id: "male-american-josh", name: "Josh", gender: "male", tone: "Young & energetic" },
  { id: "male-american-adam", name: "Adam", gender: "male", tone: "Deep & narrative" },
  { id: "male-american-drew", name: "Drew", gender: "male", tone: "Versatile" },
  { id: "male-british-dave", name: "Dave", gender: "male", tone: "British, conversational" },
  { id: "male-irish-fin", name: "Fin", gender: "male", tone: "Irish, warm" },
  { id: "male-australian-charlie", name: "Charlie", gender: "male", tone: "Australian, friendly" },
];

// Plain-language summary of what the chosen voice option will produce
export const describeVoice = (option, clonedVoices = []) => {
  if (!option || option === "none" || option === "auto" || option === "lip_sync") return "Character speaks in its own voice (native)";
  if (option === "visuals-only") return "No voice (silent video)";
  if (option.startsWith("cloned:")) {
    const v = clonedVoices.find((c) => `cloned:${c.voice_id}` === option);
    return `${v?.name || "My voice"} voiceover (lips synced to it)`;
  }
  const preset = PRESET_VOICES.find((v) => v.id === option);
  return `${preset?.name || option} voiceover (lips synced to it)`;
};
